import css from 'styled-jsx/css';

const styles = css.global`#santander-menu {
  position: fixed;
  z-index: 9998;
  top: 80px;
  left: 0;
  width: 100%;
}

#santander-menu,
#santander-menu amp-mega-menu > nav,
#santander-menu .mega-menu-ampless > nav {
  background: none;
  background-color: #cc0000;
}

#santander-menu amp-mega-menu ul,
#santander-menu .mega-menu-ampless ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

#santander-menu amp-mega-menu > nav,
#santander-menu amp-mega-menu ul,
#santander-menu amp-mega-menu ul > li,
#santander-menu .mega-menu-ampless > nav,
#santander-menu .mega-menu-ampless ul,
#santander-menu .mega-menu-ampless ul > li {
  height: 100%;
}

#santander-menu amp-mega-menu ul > li,
#santander-menu .mega-menu-ampless ul > li {
  height: 100%;
  margin-right: 48px;
}

#santander-menu amp-mega-menu ul > li > span,
#santander-menu amp-mega-menu ul > li > a,
#santander-menu .mega-menu-ampless ul > li > span,
#santander-menu .mega-menu-ampless ul > li > a {
  color: #fff;
  font-size: 18px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* importante não colocar divs exatamente dentro do amp-mega-menu para poder esconder a mask */
#santander-menu > amp-mega-menu > div,
#santander-menu > .mega-menu-ampless > div {
  visibility: hidden;
  display: none;
}

#santander-menu .menu-content {
  border: 1px solid #979797;
  padding: 32px 0;
}

#santander-menu .menu-col {
  min-width: 321px;
}

#santander-menu .menu-col > p {
  margin: 0;
  margin-left: 16px;
  margin-bottom: calc(28px - 16px);
  color: #000;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 175% */
}

#santander-menu .menu-col > div {
  border-bottom: 1px solid #cccccc;
  padding: 16px 0;
  position: relative;
}

#santander-menu .menu-col p,
#santander-menu .menu-col a {
  margin: 0;
  margin-left: 16px;
}

#santander-menu .menu-col a{
  cursor: pointer;
  color: #000;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 175% */
}

#santander-menu .menu-col .flag-destaque {
  background-color: #609E55;
  border-radius: 4px;
  color: #ffffff;
  border: none;
  font-family: 'SantanderHeadline';
  font-size: 14px;
  padding: 8px 10px;
  position: absolute;
  right: 0;
  bottom: 9px;
}

#santander-menu .menu-content .content-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

#santander-menu .menu-col:nth-child(2) {
  margin: 0 56px;
}

#santander-menu .no-border {
  border: none;
}

#santander-menu a {
  text-decoration: none;
}

#santander-menu amp-mega-menu,
#santander-menu .mega-menu-ampless {
  display: none;
}

#santander-menu .mega-menu-ampless {
  height: 60px;
  display: none;
  font-family: 'Open Sans';
}

#santander-menu .mega-menu-ampless ul {
  list-style-type: none;
}

#santander-menu .mega-menu-ampless nav,
#santander-menu .mega-menu-ampless ul,
#santander-menu .mega-menu-ampless li,
#santander-menu .mega-menu-ampless span {
  height: 100%;
}

#santander-menu .mega-menu-ampless span {
  cursor: pointer;
}

#santander-menu .mega-menu-ampless ul li > div.closed {
  display: none;
  background-color: #fff;
}

#santander-menu .mega-menu-ampless ul li > div.opened {
  position: absolute;
  width: 100%;
  left: 0;
  background-color: #fff;
}

.dismiss-menu {
  display: none;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}


@media (min-width: 992px) {
  #santander-menu amp-mega-menu,
  #santander-menu .mega-menu-ampless {
    display: block;
  }

  .dismiss-menu {
    display: flex;
    z-index: 10;
  }
}



/* MENU MOUSEOVER */
#santander-menu .menu-content.opened{
  display: none;
}
#santander-menu amp-mega-menu{
  overflow: visible !important;
}
#santander-menu li span+div{
  position: absolute;
  width: 100%;
  left: 0;
  background-color: #fff;
  opacity: 1 !important;
  -webkit-transition: -webkit-transform .1s ease-in;
  transition: -webkit-transform .1s ease-in;
  -o-transition: -o-transform .1s ease-in;
  -moz-transition: transform .1s ease-in, -moz-transform .1s ease-in;
  transition: transform .1s ease-in;
  transition: transform .1s ease-in, -webkit-transform .1s ease-in, -moz-transform .1s ease-in, -o-transform .1s ease-in;
  display: block !important;
  -webkit-transform: scaleY(0);
    -moz-transform: scaleY(0);
      -ms-transform: scaleY(0);
      -o-transform: scaleY(0);
          transform: scaleY(0);
  -webkit-transform-origin: top;
    -moz-transform-origin: top;
      -ms-transform-origin: top;
      -o-transform-origin: top;
          transform-origin: top;
}
#santander-menu li:hover span+div{
  visibility: visible !important;
  -webkit-transform: scaleY(1);
    -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
          transform: scaleY(1);
}
#santander-menu li span+div > div{
  opacity: 0;
  visibility: hidden;
  -webkit-transition: visibility .1s ease-in-out;
  -o-transition: visibility .1s ease-in-out;
  -moz-transition: visibility .1s ease-in-out;
  transition: visibility .1s ease-in-out;
  -webkit-transition: opacity .6s ease-in-out;
  -o-transition: opacity .6s ease-in-out;
  -moz-transition: opacity .6s ease-in-out;
  transition: opacity .6s ease-in-out;
}
#santander-menu li:hover span+div > div{
  visibility: visible;
  opacity: 1;
}
#santander-menu  li > span {
  position: relative;
  z-index: 1;
  -webkit-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  -moz-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
}
#santander-menu  li:hover > span {
  color: #cc0000 !important;
  -webkit-text-stroke: #cc0000 .5px;
}
#santander-menu  li:hover > span:after {
  content: '';
  background: white;
  width: -webkit-calc(100% + 50px);
  width: -moz-calc(100% + 50px);
  width: calc(100% + 50px);
  height: 90%;
  -webkit-border-radius: 4px 4px 0 0;
    -moz-border-radius: 4px 4px 0 0;
          border-radius: 4px 4px 0 0;
  bottom: -1px;
  position: absolute;
  z-index: -1;
}`;

export default styles;